function SettingSection({ title, children }) {
    return (
      <div className="settingSection">
        <div className="title">{title}</div>
        <div>{children}</div>
      </div>
    );
  }

  export default SettingSection;